'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _components = require('components');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ButtonUploader = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ButtonUploader, _Component);

  function ButtonUploader() {
    var _ref;

    (0, _classCallCheck3.default)(this, ButtonUploader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ButtonUploader.__proto__ || (0, _getPrototypeOf2.default)(ButtonUploader)).call.apply(_ref, [this].concat(args)));

    _this._uploaderOnComplete = function () {
      _this.setState({ loading: false });
    };

    _this._uploaderOnUpload = function () {
      _this.setState({ loading: true });
    };

    _this._setUploaderCallbacks = function (isOn) {
      var callbacks = _this.props.callbacks;

      (0, _entries2.default)(callbacks).map(function (_ref2) {
        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
            cbName = _ref3[0],
            cb = _ref3[1];

        _this.uploader[isOn ? 'on' : 'off'](cbName, cb);
      });
    };

    _this.state = { loading: false };
    return _this;
  }

  (0, _createClass3.default)(ButtonUploader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get3.default)(ButtonUploader.prototype.__proto__ || (0, _getPrototypeOf2.default)(ButtonUploader.prototype), 'componentDidMount', this).call(this, this._mountUploader);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _get3.default)(ButtonUploader.prototype.__proto__ || (0, _getPrototypeOf2.default)(ButtonUploader.prototype), 'componentWillUnmount', this).call(this, this._unMountUploader);
    }
  }, {
    key: '_mountUploader',
    value: function _mountUploader() {
      var FineUploaderTraditional = require('components/FineUploader/traditional');
      var uploaderParams = this.props.uploaderParams;


      this.uploader = new FineUploaderTraditional({
        request: { params: uploaderParams.queryParams },
        // request: {params: {...uploaderParams.queryParams, qquuid: '685ba435-321a-4439-a370-440e965e8a68'}, uuidName: 'uuid'},
        chunking: { success: { endpoint: uploaderParams.endpoint } }
      });

      this.uploader.on('complete', this._uploaderOnComplete);
      this.uploader.on('upload', this._uploaderOnUpload);
      this._setUploaderCallbacks(true);
    }
  }, {
    key: '_unMountUploader',
    value: function _unMountUploader() {
      if (!this.uploader) {
        return null;
      }
      this.uploader.off('complete', this._uploaderOnComplete);
      this.uploader.off('upload', this._uploaderOnUpload);
      this._setUploaderCallbacks(false);
      this.uploader.methods.cancelAll();
      this.uploader = null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          isMounted = _state.isMounted,
          loading = _state.loading;
      var _props = this.props,
          label = _props.label,
          accept = _props.accept,
          multiple = _props.multiple,
          buttonClass = _props.buttonClass; // eslint-disable-line no-unused-vars

      return _react2.default.createElement(
        'div',
        { className: 'inline-block' },
        isMounted && _react2.default.createElement(
          'span',
          null,
          loading ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
            _components.FileInput,
            { uploader: this.uploader, accept: accept, multiple: multiple },
            _react2.default.createElement(
              'span',
              { className: 'btn ' + (buttonClass || 'btn-default') },
              label
            )
          )
        )
      );
    }
  }]);
  return ButtonUploader;
}(_ClientSideComponent2.default), _class2.propTypes = {
  accept: _propTypes2.default.string,
  buttonClass: _propTypes2.default.string,
  callbacks: _propTypes2.default.object,
  label: _propTypes2.default.string,
  multiple: _propTypes2.default.bool,
  uploaderParams: _propTypes2.default.object.isRequired
}, _class2.defaultProps = {
  multiple: false,
  callbacks: {}
}, _temp), (_applyDecoratedDescriptor(_class.prototype, '_mountUploader', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_mountUploader'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_unMountUploader', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_unMountUploader'), _class.prototype)), _class);
exports.default = ButtonUploader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/ButtonUploader.js
// module id = 823
// module chunks = 1